/*
 * Joon — enforce a single watch engraving
 * ------------------------------------------------------------------
 * The engraving options (e.g. "Back of Watch", "Face of the Watch") are
 * rendered by the engraving app as `.aeng-option` elements that toggle an
 * `is-selected` class. Within one option group the app is already single-
 * select, but if a product exposes the engravings as TWO separate groups a
 * customer could pick one from each and add two engravings.
 *
 * This guard treats ALL watch-engraving options across the page as one
 * mutually-exclusive set: selecting one engraving automatically deselects any
 * other selected engraving, using the app's own click-to-deselect so the line
 * item / property is properly removed. Gift-wrap and other option groups are
 * left untouched. Original, self-contained code.
 * ------------------------------------------------------------------
 */
(function () {
  "use strict";

  // Identifies watch-engraving options (not gift wrap, packaging, etc.).
  var ENGRAVE_RX = /engrav|watch/i;

  function optionText(opt) {
    return (opt.getAttribute("data-title") || opt.textContent || "");
  }

  // An option is an engraving if its own label matches, or its group is
  // introduced by an "Engrave…" heading (and NOT a gift/wrap/pack heading).
  function isEngravingOption(opt) {
    if (ENGRAVE_RX.test(optionText(opt))) return true;
    var group = opt.closest(".aeng-options");
    if (!group) return false;
    var el = group, hops = 0;
    while (el && hops < 6) {
      var prev = el.previousElementSibling;
      while (prev) {
        var txt = (prev.textContent || "").trim();
        if (txt && txt.length < 60) {
          if (/engrav/i.test(txt)) return true;
          if (/gift|wrap|pack/i.test(txt)) return false;
        }
        prev = prev.previousElementSibling;
      }
      el = el.parentElement; hops++;
    }
    return false;
  }

  var guard = false;

  document.addEventListener("click", function (e) {
    if (guard) return;
    var opt = e.target && e.target.closest ? e.target.closest(".aeng-option") : null;
    if (!opt || !isEngravingOption(opt)) return;

    // Let the app handle its own click first, then enforce single selection.
    setTimeout(function () {
      if (!opt.classList.contains("is-selected")) return; // click was a deselect
      var others = Array.prototype.slice.call(document.querySelectorAll(".aeng-option.is-selected"))
        .filter(function (o) { return o !== opt && isEngravingOption(o); });
      if (!others.length) return;
      guard = true;
      others.forEach(function (o) { try { o.click(); } catch (err) {} });
      guard = false;
    }, 0);
  }, false);
})();
